export default __webpack_public_path__ + "static/media/BankStatement.6bc20571.pdf";